module.exports = __webpack_public_path__ + "static/media/art-moderne-illustration-1.bb3c4dd9.jpg";